import {
  Home as HomeIcon,
  HeartPulse,
  Stethoscope,
  Car,
  PiggyBank,
  TrendingUp,
  Building2,
} from "lucide-react";

export const CATEGORIES = [
  {
    slug: "hogar",
    label: "Hogar",
    icon: HomeIcon,
    short: "Resguardo del patrimonio inmueble.",
    problem:
      "Tu casa es más que un activo: es el refugio donde se construye tu historia. Un siniestro inesperado —incendio, robo, sismo— puede comprometer años de esfuerzo.",
    benefit:
      "Diseñamos una cobertura integral que protege estructura, contenidos y responsabilidad civil, calibrada al valor real de tu propiedad y a tu ubicación.",
    bullets: [
      "Valuación profesional sin costo",
      "Comparativo entre 6 aseguradoras",
      "Asesoría ante siniestros en menos de 24h",
    ],
  },
  {
    slug: "vida",
    label: "Vida",
    icon: HeartPulse,
    short: "Continuidad financiera para los tuyos.",
    problem:
      "El mayor riesgo financiero de una familia no es perder un bien material, sino perder a quien sostiene el proyecto patrimonial.",
    benefit:
      "Una póliza de vida bien estructurada se convierte en un instrumento de planeación: liquidez inmediata, libre de juicios sucesorios y con beneficios fiscales.",
    bullets: [
      "Estrategias de vida temporal y vitalicia",
      "Suma asegurada calibrada a tu nivel de vida",
      "Beneficiarios designados con claridad legal",
    ],
  },
  {
    slug: "salud",
    label: "Salud",
    icon: Stethoscope,
    short: "Acceso a la mejor medicina sin sobresaltos.",
    problem:
      "Un tratamiento médico mayor puede consumir en semanas lo que tomó décadas construir. La medicina privada de alta especialidad exige previsión.",
    benefit:
      "Te conectamos con esquemas de gastos médicos mayores con red hospitalaria nacional e internacional, deducible inteligente y cobertura preexistencias.",
    bullets: [
      "Hospitales premium nacionales e internacionales",
      "Cobertura para padecimientos crónicos",
      "Renovación garantizada de por vida",
    ],
  },
  {
    slug: "automovil",
    label: "Automóvil",
    icon: Car,
    short: "Movilidad sin exposición patrimonial.",
    problem:
      "Un percance vial puede derivar en responsabilidades civiles que superan por mucho el valor del vehículo.",
    benefit:
      "Coberturas amplias con asistencia premium, autos sustitutos de gama y blindaje frente a daños a terceros.",
    bullets: [
      "Auto sustituto en categoría equivalente",
      "RC hasta 5 millones de pesos",
      "Atención 24/7 en accidentes",
    ],
  },
  {
    slug: "ahorro",
    label: "Ahorro",
    icon: PiggyBank,
    short: "Capital disciplinado para tus objetivos.",
    problem:
      "Ahorrar sin estructura erosiona el rendimiento real. La inflación silenciosamente reduce tu poder adquisitivo año tras año.",
    benefit:
      "Diseñamos vehículos de ahorro indexados, en pesos y dólares, con horizontes de mediano y largo plazo, y beneficios fiscales aplicables.",
    bullets: [
      "Ahorro programado en USD y MXN",
      "Estrategias deducibles ISR",
      "Liquidez parcial sin penalización",
    ],
  },
  {
    slug: "inversiones",
    label: "Inversiones",
    icon: TrendingUp,
    short: "Portafolios alineados a tu perfil.",
    problem:
      "Concentrar capital en un solo instrumento expone tu patrimonio a volatilidad innecesaria.",
    benefit:
      "Construimos portafolios diversificados —deuda gubernamental, fondos indexados, ETFs internacionales y activos alternativos— alineados a tu tolerancia al riesgo.",
    bullets: [
      "Asset allocation profesional",
      "Reportes trimestrales de desempeño",
      "Acompañamiento de asesor dedicado",
    ],
  },
  {
    slug: "empresas",
    label: "Empresas",
    icon: Building2,
    short: "Continuidad operativa y blindaje corporativo.",
    problem:
      "Un siniestro mayor, una demanda laboral o la pérdida de un socio clave puede detener la operación de toda una empresa.",
    benefit:
      "Diseñamos programas integrales: daños, RC empresarial, vida grupo de colaboradores, key-man y planes de beneficios.",
    bullets: [
      "Programas a la medida del giro",
      "Vida grupo y gastos médicos para empleados",
      "Seguros de key-man y socios",
    ],
  },
];

export const getCategory = (slug) => CATEGORIES.find((c) => c.slug === slug);
